import React from 'react';
import { Icon } from 'ui';
import { useFeatureFlags } from 'components/shared/hooks';
import Attempt from './Attempt';

const Attempts = ({
  attempts,
  hippoPreviewBase,
  hippoThumbnailBase,
  ziggeoApiKey,
}) => {
  const hasZiggeoForAllMedia = useFeatureFlags(['ziggeo_for_all_media']);
  return (
    <table
      className="DataTable Table tablesaw-stack LearnerOverview-completionsTable"
      data-tablesaw-mode="stack"
    >
      <thead>
        <tr>
          <th className="DataTable-name">
            {t('practice.on_demand_practice.general.prompt')}
          </th>
          <th>
            <span>
              {t(
                'practice.on_demand_practice.overview.learner_page.completion_date',
              )}
              <Icon name="triangle_down" className="LearnerOverview-arrow" />
            </span>
          </th>
          <th className="DataTable-name">
            {t(
              'practice.on_demand_practice.overview.learner_page.given_response',
            )}
          </th>
        </tr>
      </thead>
      <tbody>
        {attempts.map(attempt => (
          <Attempt
            key={attempt.id}
            prompt={prompt}
            attempt={attempt}
            apiKey={ziggeoApiKey}
            hippoPreviewBase={hippoPreviewBase}
            hippoThumbnailBase={hippoThumbnailBase}
            hasZiggeoForAllMedia={hasZiggeoForAllMedia}
          />
        ))}
      </tbody>
    </table>
  );
};

export default Attempts;
